// src/i18n/pl/views/iframes.js
export const iframes = {
  pricing: {
    title: "Kalkulator cen",
    description:
      "Skonfiguruj ceny bazowe i dopłaty za jednostkę w każdym planie; na fakturach podatek jest osobną pozycją.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "Wideo: Kalkulator cen (EN)",
  },
  connectBooking: {
    title: "Podłącz Booking.com",
    description:
      "Przewodnik krok po kroku, jak połączyć obiekt z Booking.com przez channel manager.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "Wideo: Podłącz Booking.com (EN)",
  },
  connectAirbnb: {
    title: "Podłącz Airbnb (przez Channex)",
    description:
      "Włącz połączenie z Airbnb z poziomu swojego PMS za pomocą Channex i synchronizuj dostępność oraz ceny.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "Wideo: Podłącz Airbnb (EN)",
  },
  channexCertification: {
    title: "Certyfikacja Channex · PMS",
    description:
      "Wymagania i testy niezbędne do ukończenia certyfikacji PMS w Channex (pełna synchronizacja, ceny, ograniczenia).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "Wideo: Certyfikacja Channex (EN)",
  },
  hotelCalendar: {
    title: "Kalendarz hotelowy (wiele pokoi)",
    description:
      "Zarządzaj rezerwacjami według typu i egzemplarza pokoju; unikaj overbookingu dzięki uporządkowanemu widokowi.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "Wideo: Kalendarz hotelowy (EN)",
  },
  apartmentCalendar: {
    title: "Kalendarz apartamentów",
    description:
      "Blokady, ceny dzienne i pobyty w kalendarzu każdego obiektu.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "Wideo: Kalendarz apartamentów (EN)",
  },
  guestCheckin: {
    title: "Check-in przez WhatsApp",
    description:
      "Goście skanują dokument tożsamości, przechodzą weryfikację i podpisują się cyfrowo na swoim telefonie.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "Wideo: Check-in przez WhatsApp (EN)",
  },
  identityVerification: {
    title: "Weryfikacja tożsamości i podpis elektroniczny",
    description:
      "Kontrola selfie, odczyt MRZ/PDF417 i bezpieczny podpis elektroniczny zgodny z wymogami prawa.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "Wideo: Weryfikacja tożsamości (EN)",
  },
  smartLocks: {
    title: "Zamki inteligentne",
    description:
      "Wysyłaj automatyczne kody dostępu, bez kluczy i bez czekania. Obsługa kodów dynamicznych.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "Wideo: Zamki inteligentne (EN)",
  },
  reviewsAutomation: {
    title: "Automatyzacja opinii",
    description:
      "Planuj przypomnienia o opiniach i buduj reputację swojego obiektu.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "Wideo: Automatyzacja opinii (EN)",
  },
};
